import qs from 'qs';

const routeQuery = {
  parse: (search: string) => qs.parse(search, { ignoreQueryPrefix: true }),
  stringify: (query: object) => qs.stringify(query, { addQueryPrefix: true }),
};

export default routeQuery;
